<ion-modal [isOpen]="isOpen()" (didDismiss)="closeModal()" mode="ios" class="date-picker-modal">
  <ng-template>
    <div class="bg-white font-body text-gray-500 w-full h-full border rounded-xl border-gray-200">
    <!-- Header -->
    <div class="px-6 py-5 border-b border-gray-200">
      <h2 class="text-md font-title font-medium text-gray-800">Fechas</h2>
    </div>

    <div class="px-5 py-5">
      <!--@ fechas preestablecidas -->
      <div class="mb-6">
        <p class="font-title text-sm text-gray-500 mb-4">
          Selecciona unas fechas preestablecidas
        </p>
        
        <div class="flex bg-gray-100 rounded-md p-0.5 h-16">
          <button 
            (click)="selectType('today')"
            [class.bg-brand-500]="draftSelection().type === 'today'"
            [class.text-white]="draftSelection().type === 'today'"
            [class.shadow-theme-sm]="draftSelection().type === 'today'"
            class="font-title flex-1 py-2.5 text-theme-sm font-medium transition-all duration-200 flex items-center justify-center leading-tight rounded-md"
            [class.text-gray-500]="draftSelection().type !== 'today'">
            Hoy
          </button>

          @if (draftSelection().type !== 'today' && draftSelection().type !== 'week') {
            <div class="w-px bg-gray-300 my-1"></div>
          }

          <button 
            (click)="selectType('week')"
            [class.bg-brand-500]="draftSelection().type === 'week'"
            [class.text-white]="draftSelection().type === 'week'"
            [class.shadow-theme-sm]="draftSelection().type === 'week'"
            class="font-title flex-1 py-2.5 text-theme-sm font-medium transition-all duration-200 flex items-center justify-center leading-tight rounded-md"
            [class.text-gray-500]="draftSelection().type !== 'week'">
            Últimos<br>7 días
          </button>

          @if (draftSelection().type !== 'week' && draftSelection().type !== 'lastMonth') {
            <div class="w-px bg-gray-300 my-1"></div>
          }

          <button 
            (click)="selectType('lastMonth')"
            [class.bg-brand-500]="draftSelection().type === 'lastMonth'"
            [class.text-white]="draftSelection().type === 'lastMonth'"
            [class.shadow-theme-sm]="draftSelection().type === 'lastMonth'"
            class="font-title flex-1 text-theme-sm font-medium transition-all duration-200 flex items-center justify-center leading-tight rounded-md text-center"
            [class.text-gray-500]="draftSelection().type !== 'lastMonth'">
            Último<br>mes
          </button>
        </div>
      </div>

      <!-- calendari section -->
      <div class="mb-2">
        <p class="font-title text-sm text-gray-500 mb-4">
          o un rango de fechas al calendario
        </p>
        
        <!--@ calendari header -->
        <div class="flex items-center justify-between mb-4">
          <button (click)="prevMonth()" class="w-11 h-10 flex items-center justify-center hover:bg-gray-50 rounded-full transition-colors">
            <lib-icon name="chevron-left"></lib-icon>
          </button>
          <h3 class="font-title text-lg font-medium text-gray-800">
            {{ monthNames[viewDate().getMonth()] }} {{ viewDate().getFullYear() }}
          </h3>
          <button (click)="nextMonth()" class="w-11 h-10 flex items-center justify-center hover:bg-gray-50 rounded-full transition-colors">
            <lib-icon name="chevron-right"></lib-icon>
          </button>
        </div>

        <!--@ calendari weekdays -->
        <div class="grid grid-cols-7 mb-4 text-center">
          @for (day of dayNames; track day) {
            <span class="text-theme-sm font-medium text-gray-500 py-1">{{ day }}</span>
          }
        </div>
        <!--@ calendari days grid -->
        <div class="grid grid-cols-7 gap-y-0.5">
          @for (date of calendarDays(); track date?.getTime(); let i = $index) {
            @if (date) {
              <div class="relative flex justify-center">
                  <!-- Selection Highlight (Range Background) -->
                  @if (isDateSelected(date) && draftSelection().startDate && draftSelection().endDate && draftSelection().startDate!.getTime() !== draftSelection().endDate!.getTime()) {
                      <div class="absolute inset-y-0 bg-gray-50"
                           [class.left-1]="isRangeStart(date)"
                           [class.right-1]="isRangeEnd(date)"
                           [class.left-0]="!isRangeStart(date)"
                           [class.right-0]="!isRangeEnd(date)"
                           [class.rounded-l-full]="isRangeStart(date) || i % 7 === 0"
                           [class.rounded-r-full]="isRangeEnd(date) || i % 7 === 6">
                      </div>
                  }
                  
                  <button 
                    (click)="toggleDate(date)"
                    [class.text-gray-300]="!isCurrentMonth(date)"
                    [class.text-gray-800]="isCurrentMonth(date) && !isRangeStart(date) && !isRangeEnd(date)"
                    [class.text-white]="isRangeStart(date) || isRangeEnd(date)"
                    [class.bg-brand-500]="isRangeStart(date) || isRangeEnd(date)"
                    class="relative z-10 w-11 h-11 flex items-center justify-center font-title rounded-full text-theme-sm font-medium transition-all duration-200"
                    [class.hover:bg-gray-50]="!isRangeStart(date) && !isRangeEnd(date)">
                    {{ date.getDate() }}
                  </button>
              </div>
            }
          }
        </div>
      </div>
    </div>

    <!-- footer -->
    <div class="p-5 border-t border-gray-200 flex justify-end gap-3">

      <lib-button
        (click)="closeModal()"
        variant="outline"
        size="sm"
        >
        Cancelar
      </lib-button>        
      <lib-button
        (click)="confirm()"
        variant="primary"
        size="sm"
        >
        Aceptar
      </lib-button>
    </div>
  </div>
  </ng-template>
</ion-modal>